import React, { useEffect, useRef, useState } from "react";
import {
  FaList,
  FaBook,
  FaStore,
  FaUser,
  FaPlus,
  FaBoxArchive,
  FaHouse,
  FaPaintbrush,
} from "react-icons/fa6";
import styles from "./BottomNavbar.module.css";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import { FaClipboardList, FaSignOutAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import LangSelector from "../Inputs/LangSelector/LangSelector";
import ThemeSelector from "../Inputs/ThemeSelector/ThemeSelector";
import sidebarStyles from "../Sidebar/Sidebar.module.css";

const BottomNavbar: React.FC = () => {
  const [showMore, setShowMore] = useState<boolean>(false);
  const [showCreate, setShowCreate] = useState<boolean>(false);
  const { logout, user } = useAuth();
  const listMenuRef = useRef<HTMLDivElement>(null);
  const createMenuRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setShowMore(false);
      setShowCreate(false);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        listMenuRef.current &&
        !listMenuRef.current.contains(event.target as Node)
      ) {
        setShowMore(false);
      }
      if (
        createMenuRef.current &&
        !createMenuRef.current.contains(event.target as Node)
      ) {
        setShowCreate(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className={styles.bottomnavbar}>
        <NavLink to="/" className={styles.unset}>
          <FaHouse />
        </NavLink>

        <NavLink to="/Collection/Cards" className={styles.unset}>
          <FaBook />
        </NavLink>
        <div onClick={() => setShowCreate(!showCreate)}>
          <div className={styles.circleIcon}>
            <FaPlus />
          </div>
        </div>
        <NavLink to={`/profile/${user?.username}`} className={styles.unset}>
          <FaUser />
        </NavLink>
        <div onClick={() => setShowMore(!showMore)}>
          <FaList />
        </div>
      </div>{" "}
      {showMore && (
        <div className={styles.expandedMenu} ref={listMenuRef}>
          <div className={sidebarStyles.themeContainer}>
            <ThemeSelector />
          </div>
          <LangSelector />
          <NavLink to="/store" className={styles.unset}>
            <div className={styles.menuItem}>
              <div className={styles.menuIcon}>
                <FaStore />
              </div>
              Store
            </div>
          </NavLink>
          <NavLink to="/Archive" className={styles.unset}>
            <div className={styles.menuItem}>
              <div className={styles.menuIcon}>
                <FaBoxArchive />
              </div>
              Archives
            </div>
          </NavLink>
          <NavLink to="/transactions" className={styles.unset}>
            <div className={styles.menuItem}>
              <div className={styles.menuIcon}>
                <FaClipboardList />
              </div>
              {t("order.label")}{" "}
            </div>
          </NavLink>{" "}
          <div className={styles.menuItem} onClick={logout}>
            <div className={styles.menuIcon}>
              <FaSignOutAlt />
            </div>
            <div>{t("logout")}</div>
          </div>
        </div>
      )}
      {showCreate && (
        <div className={styles.expandedMenu} ref={createMenuRef}>
          <NavLink to="/creator/cards" end className={styles.unset}>
            <div className={styles.menuItem}>
              <div className={styles.menuIcon}>
                <FaPaintbrush />
              </div>
              {t("creator.label")}
            </div>
          </NavLink>
          <NavLink to="/creator/cards/create" className={styles.unset}>
            <div className={styles.menuItem}>
              <div className={styles.menuIcon}>
                <FaPlus />
              </div>
              Cards
            </div>
          </NavLink>
          <NavLink to="/creator/boosters/create" className={styles.unset}>
            <div className={styles.menuItem}>
              <div className={styles.menuIcon}>
                <FaPlus />
              </div>
              Boosters
            </div>
          </NavLink>
          {/* <NavLink to="/posts/create" className={styles.unset}>
            <div className={styles.menuItem}>
              <div className={styles.menuIcon}>
                <FaPlus />
              </div>
              Posts
            </div>
          </NavLink> */}
        </div>
      )}
    </>
  );
};

export default BottomNavbar;
